<template>
  <div ref="tableContainer">
    <div style="clear:both">
      <el-select
        v-model="selectedCountryID"
        class="search-select"
        type="select"
        style="float:left;margin-bottom:10px"
        :placeholder="$t('common.country')"
        @input="handleFilterChange"
      >
        <el-option v-for="country in countries" :key="country.id" :label="country.name" :value="country.id" />
      </el-select>
      <date-picker
        v-model="validDate"
        :show-week-numbers="false"
        :placeholder="$t('common.date')"
        style="float:left;margin-left:10px"
        class="search-select"
        @input="handleFilterChange"
      />
    </div>
    <el-table
      v-if="selectedCountryID"
      id="crudPriceListItems"
      ref="crudPriceListItems"
      :data="transformedItems"
      border
      fit
      style="width: 100%"
      :max-height="getMaxTableHeight()"
    >
      <el-table-column>
        <el-table-column :label="$t('priceListItem.height')">
          <template slot-scope="scope">
            <span>{{ scope.row.height }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column v-for="(width, i) in widths" :key="width" :label="i === 0 ? $t('priceListItem.width') : ''">
        <el-table-column :label="width">
          <template slot-scope="scope">
            <span>{{ scope.row[width].price }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DatePicker from '@/components/DSE/DatePicker';
import { PriceTypeOption } from '@/utils/constants';
import { toDateString } from '@/utils/date';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      items: [],
      selectedCountryID: null,
      selectedCultureID: null,
      transformedItems: [],
      validDate: toDateString(new Date()),
      widths: []
    };
  },
  computed: {
    countries() {
      return this.$store.getters['country/loadedItems'];
    },
    listParams() {
      return {
        priceListItemID: this.priceListItemID,
        priceTypeOption: PriceTypeOption.WorkshopPrice,
        countryID: this.selectedCountryID,
        validDate: this.validDate
      };
    },
    priceListItemID() {
      return +this.$route.params.id;
    }
  },
  created() {},
  methods: {
    createMatrix() {
      this.setWidths();
      this.transformLengthsIntoRows();
    },
    getMaxTableHeight() {
      if (this.$refs.tableContainer) {
        const spaceForButtons = 150;
        return window.innerHeight - this.$refs.tableContainer.getBoundingClientRect().top - spaceForButtons;
      }
    },
    handleFilterChange() {
      if (this.selectedCountryID) {
        this.refreshList();
      }
    },
    setWidths() {
      let itemsSortedBywidth = [...this.items];
      itemsSortedBywidth = itemsSortedBywidth.sort((a, b) => {
        return a.widthInCm - b.widthInCm;
      });
      this.widths = [...new Set(itemsSortedBywidth.map(i => i.widthInCm.toString()))];
    },
    refreshList() {
      this.loading = true;
      this.$store
        .dispatch('priceListItem/getPriceMatrix', this.listParams)
        .then(data => {
          this.items = data.items;
          this.createMatrix();
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    transformLengthsIntoRows() {
      const transformedItems = {};
      this.items.forEach(i => {
        if (!transformedItems[i.heightInCm]) {
          transformedItems[i.heightInCm] = { height: i.heightInCm };
        }
        transformedItems[i.heightInCm][i.widthInCm] = {
          price: i.price
        };
      });
      this.transformedItems = Object.entries(transformedItems).map(x => x[1]);
    }
  }
};
</script>

<style lang="scss" scoped></style>
